import { Facilities as FacilitiesComponent } from '@/ui/components/facilities';
import { getChannel, getDocument, getPlaceId } from '@lib/server';
import { Place, SocialWithContact } from '@types';

import { BlockBase } from './utils';

export async function Facilities({
  params,
  id,
}: {
  show: { value: keyof SocialWithContact }[];
} & BlockBase) {
  const channel = await getChannel(decodeURIComponent(params.domain));

  if (!channel?.channelId || !params.venue) return null;

  const { placeId } = await getPlaceId(channel, decodeURIComponent(params.venue));

  if (!placeId) return null;

  const { fields } = await getDocument<Place>('place', placeId, {
    depth: 0,
    select: ['fields.default.facilities'],
    tags: [channel.channelId],
  });

  const facilities = fields?.default?.facilities || [];

  if (!facilities.length) return null;

  return <FacilitiesComponent facilities={facilities} className="px-4 sm:px-8" id={id} />;
}
